import styled, { keyframes } from 'styled-components'

import media from '../../../services/generateMediaQueries'
import Spinner from '../../ui/Spinner/Spinner'

export const FadeInOut = keyframes`
0% { opacity:0; }

5% { opacity:1; }

95% { opacity:1; }
100% { opacity:0; }
`

export const PromoCodeContainer = styled.div`
  place-content: center;
  width: 100%;
  display: flex;
  margin: 0.5rem 0;
  input {
    border: none;
    flex: 1;
    background-color: #d6eae7;
    color: var(--color-primary);
    text-transform: uppercase;
    font-size: 1.1rem;
    font-weight: var(--font-weight-boldest);
    font-family: var(--font-family-base);
    height: 3rem;
    border-radius: var(--border-radius-form) 0 0 var(--border-radius-form);
    text-align: center;
    letter-spacing: 0.5px;
  }
  input:focus,
  button:focus {
    outline: 0;
  }
  input::selection {
    background: transparent;
  }
  button {
    cursor: pointer;
    padding: 0.5rem 0.75rem;
    border: none;
    background-color: var(--color-primary);
    color: var(--color-bg-light);
    border-radius: 0 var(--border-radius-form) var(--border-radius-form) 0;
    display: flex;
    img {
      margin: auto;
      height: 1.5rem;
    }
  }
`

export const LoadingSpinner = styled(Spinner)`
  img {
    max-width: 30px !important;
  }
`

export const ToolTip = styled.div`
position: fixed;
left: rem;
right: 0;
bottom: 0;
margin: 2rem;
padding: 0.5rem 1rem;
background: var(--color-bg-form);
border-radius: var(--border-radius-small);
font-weight: var(--font-weight-bold);
color: var(--color-primary);

${media.lessThan('small')`
    width: -webkit-fill-available;
`}

animation-name: ${FadeInOut};
animation-duration: 5s;
animation-timing-function: ease-in;
animation-iteration-count: 1;
animation-fill-mode: forwards;
`
